import React from "react";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { editorialImageSrcSet } from "../utils/images";

function EditorialCard({ entry, type }) {
  const relatedProducts = entry.productIds
    .map((productId) => productData.find((product) => product.id === productId))
    .filter(Boolean);
  const isRecipe = type === "recipe";
  const headingId = `${entry.slug}-title`;
  const imageSource =
    entry.image || relatedProducts[0]?.images?.[0] || "/main/hero-pantry.jpg";

  return (
    <article
      className={`editorial-card${entry.featured ? " editorial-card--featured" : ""}`}
      id={entry.slug}
      aria-labelledby={headingId}
    >
      <div className="editorial-card__media">
        <img
          src={imageSource}
          srcSet={editorialImageSrcSet(imageSource)}
          sizes="(max-width: 700px) 100vw, 50vw"
          alt=""
          width={imageSource.startsWith("/img/") ? "1200" : "1800"}
          height={imageSource.startsWith("/img/") ? "1200" : "1200"}
          loading={entry.featured ? "eager" : "lazy"}
          decoding="async"
        />
        {entry.featured && <span>Editor&apos;s pick</span>}
      </div>

      <div className="editorial-card__body">
        <div className="editorial-card__meta">
          <span>{entry.category}</span>
          <span>{entry.readTime}</span>
          {isRecipe && <span>{entry.time}</span>}
          {isRecipe && <span>Serves {entry.serves}</span>}
        </div>
        <h2 id={headingId}>{entry.title}</h2>
        <p className="editorial-card__excerpt">{entry.excerpt}</p>

        <details className="editorial-card__details">
          <summary>{isRecipe ? "Open cooking notes" : "Read the journal note"}</summary>
          <div className="editorial-card__details-copy">
            <p>{entry.intro}</p>
            <p>{entry.notes}</p>
            {relatedProducts.length > 0 && (
              <div className="editorial-card__products">
                <h3>{isRecipe ? "From the pantry" : "Explore the ingredients"}</h3>
                <ul>
                  {relatedProducts.map((product) => (
                    <li key={product.id}>
                      <Link to={`/product/${product.slug}`}>{product.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </details>
      </div>
    </article>
  );
}

export default EditorialCard;
